import { $ctx, $prose } from '@milkdown/kit/utils';
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { DecorationSet, Decoration } from '@milkdown/kit/prose/view';
import { findParent } from '@milkdown/kit/prose';
import { i as isInCodeBlock, a as isInList } from './index-Jvxff1vU.js';

function isDocEmpty(doc) {
  var _a;
  return doc.childCount <= 1 && !((_a = doc.firstChild) == null ? void 0 : _a.content.size);
}
function createPlaceholderDecoration(state, placeholderText) {
  const { selection } = state;
  if (!selection.empty)
    return null;
  const $pos = selection.$anchor;
  const node = $pos.parent;
  if (node.content.size > 0)
    return null;
  const inTable = findParent((node2) => node2.type.name === "table")($pos);
  if (inTable)
    return null;
  const before = $pos.before();
  return Decoration.node(before, before + node.nodeSize, {
    "class": "crepe-placeholder",
    "data-placeholder": placeholderText
  });
}
const placeholderConfig = $ctx({
  text: "Please enter...",
  mode: "block"
}, "placeholderConfigCtx");
const placeholderPlugin = $prose((ctx) => {
  return new Plugin({
    key: new PluginKey("CREPE_PLACEHOLDER"),
    props: {
      decorations: (state) => {
        var _a;
        const config = ctx.get(placeholderConfig.key);
        if (config.mode === "doc" && !isDocEmpty(state.doc))
          return null;
        if (isInCodeBlock(state.selection) || isInList(state.selection))
          return null;
        const placeholderText = (_a = config.text) != null ? _a : "Please enter...";
        const deco = createPlaceholderDecoration(state, placeholderText);
        if (!deco)
          return null;
        return DecorationSet.create(state.doc, [deco]);
      }
    }
  });
});
const defineFeature = (editor, config) => {
  editor.config((ctx) => {
    if (config) {
      ctx.update(placeholderConfig.key, (prev) => {
        return {
          ...prev,
          ...config
        };
      });
    }
  }).use(placeholderPlugin).use(placeholderConfig);
};

export { defineFeature, placeholderConfig, placeholderPlugin };
//# sourceMappingURL=index-CMGDOz11.js.map
